import { mapGetters } from 'vuex'

const mixin = {
  computed: {
    ...mapGetters('auth', ['allowedFeature'])
  }
}

export default mixin
